import React from 'react';
import { Calendar, Building2, Users, BarChart3, Shield, Headphones, Check } from 'lucide-react';
import Card from '../../components/Card';

interface SignupProps {
  onSwitch: () => void;
  onSuccess: () => void;
}

const CALENDLY_URL = 'https://calendly.com/ad-blue-pill/30min';

const enterpriseFeatures = [
  { icon: Users, text: 'Unlimited AI audience simulations' },
  { icon: BarChart3, text: 'Custom data sets & tailored workflows' },
  { icon: Building2, text: 'Dedicated account management' },
  { icon: Shield, text: 'Enterprise-grade security & compliance' },
  { icon: Headphones, text: 'Priority support & onboarding' },
];

const Signup: React.FC<SignupProps> = ({ onSwitch }) => {
  return (
    <Card className="w-full max-w-md mx-auto p-8">
      <div className="text-center mb-8">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gray-900 mb-4">
          <Building2 className="h-7 w-7 text-white" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Get Started with Blue Pill</h1>
        <p className="text-gray-600">
          Book a meeting with our team to explore how AI-powered audience research can transform your business.
        </p>
      </div>

      <div className="space-y-3 mb-8">
        {enterpriseFeatures.map(({ icon: Icon, text }) => (
          <div key={text} className="flex items-center gap-3">
            <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-gray-50 flex items-center justify-center">
              <Icon className="w-4 h-4 text-gray-700" />
            </div>
            <span className="text-sm text-gray-700">{text}</span>
          </div>
        ))}
      </div>

      <div className="bg-gray-50 rounded-lg p-4 mb-8">
        <div className="flex items-start gap-3">
          <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-gray-900">Personalized demo included</p>
            <p className="text-xs text-gray-500 mt-0.5">
              See the platform in action with your own use case during a 30-minute call.
            </p>
          </div>
        </div>
      </div>

      <button
        onClick={() => window.open(CALENDLY_URL, '_blank')}
        className="w-full flex items-center justify-center gap-2 py-3 px-4 rounded-md font-medium text-white bg-gray-900 hover:bg-gray-800 transition-colors"
      >
        <Calendar className="h-5 w-5" />
        Book a Meeting
      </button>

      <div className="mt-8 text-center">
        <p className="text-sm text-gray-600">
          Already have an account?{' '}
          <button
            onClick={onSwitch}
            className="font-medium text-blue-600 hover:text-blue-500"
          >
            Sign in
          </button>
        </p>
      </div>
    </Card>
  );
};

export default Signup;
